import { render, staticRenderFns } from "./LiveSequenzialeRR.vue?vue&type=template&id=4c73b4e8&scoped=true&"
import script from "./LiveSequenzialeRR.vue?vue&type=script&lang=js&"
export * from "./LiveSequenzialeRR.vue?vue&type=script&lang=js&"
import style0 from "./LiveSequenzialeRR.vue?vue&type=style&index=0&id=4c73b4e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c73b4e8",
  null
  
)

export default component.exports